<template>
    <div class="codelab-mission-item" @click="onMissionClick"
        :class="[{finished: mission.isFinish, active: mission.status === 'active'}, shit$(`b:1px; bc:${formatStyleValue(mission.starBorderColor)}; bgc:${formatStyleValue(mission.bgColor)}!; hover:bgc:${formatStyleValue(mission.bgHoverColor)}!;`)]">
        <!-- style="background: #EC7554;" -->
        <el-image :src="mission.screenshot + queryToken" class="screenshot" lazy>
            <div slot="placeholder" class="image-slot">
                <svg-icon href="#codelab-mission-thumb" width="60" height="60"></svg-icon>
            </div>
            <div slot="error" class="image-slot">
                <svg-icon href="#codelab-mission-thumb-error" width="32" height="32"></svg-icon>
            </div>
        </el-image>
        <div class="bottom">
            <div class="difficult">
                <el-rate
                    disabled-void-icon-class="el-icon-star-off"
                    disabled-void-color="#a8a8ac"
                    v-model="difficulty"
                    :disabled="true"
                    >
                </el-rate>
            </div>
            <div class="mission-title" :class="shit$(`c:${formatStyleValue(mission.textColor)}!;`)">{{mission.cardNumber}}&nbsp;{{mission.title}}</div>
        </div>
        <div class="lock-mask" v-if="mission.lock$">
            <svg-icon href="#codelab-icon-lock" :width="80" :height="100" color="#ffffff"></svg-icon>
        </div>
    </div>
</template>
<script>
const apiKey = process.env.VUE_APP_api_key;
export default {
    name: "mission-item",
    props: {
        mission: Object
    },
    data () {
        return {
            queryToken: "?apiKey=" + apiKey
        }
    },
    computed: {
        difficulty: {
            get () { return Number(this.mission.difficulty) },
            set (a) { this.mission.difficulty = a }
        }
    },
    methods: {
        formatStyleValue (styleVal) {
            return styleVal.indexOf(',') > -1 ? `rgba(${styleVal})` : styleVal
        },
        onMissionClick () {
            this.$emit("select", this.mission);
        }
    },
}
</script>
<style lang="scss">

    .codelab-mission-item{
        .el-icon-star-off {
            -webkit-text-stroke: 1px transparent!important;
            &::before {
                content: "\e797";
            }
        }
        .el-icon-star-on {
            color: #ffc229!important;
        }
        .el-rate__icon {
            -webkit-text-stroke: 1px #696969;
        }
        $screenshot-height: 190px;
        width: 100%;
        height: 100%;
        border-radius: 6px;
        overflow: hidden;
        position: relative;
        transition: transform ease-out 0.2s;
        &.active{
            &:hover{
                transform: translateY(-10px);
                
                box-shadow: 0 0 5px rgba(0,0,0,0.5);
                .mask{
                    background: rgba(255,255,255,0.2);
                }
            }
        }
        .screenshot{
            width: 100%;
            height: $screenshot-height;
            line-height: $screenshot-height;
            text-align: center;
            background-color: #ffffff;
            .image-slot{
                width: 100%;
                height: 100%;
            }
        }
        .bottom{
            padding: 12px 18px;
            .difficult{
                width: 100%;
            }
            .mission-title{
                padding-top: 6px;
                font-size: 16px;
                line-height: 1.5em;
                color: #ffffff;
            }
        }
        .mask,.lock-mask{
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 1;
        }
        .lock-mask{
            background: rgba(31,31,31,0.5);
            text-align: center;
            line-height: $screenshot-height;
            pointer-events: none;
            z-index: 2;
        }
        .mission-pass-marker{
            width: 50px;
            height: 50px;
            text-align: center;
            line-height: 50px;
            border-radius: 25px;
            position: absolute;
            top: 10px;
            right: 10px;
        }
      
    }
</style>